










































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "@/models/Application";
import { Debouncer } from "@/models/Debouncer";
import { Restaurant } from "../../viewmodels/Restaurant";

@Component({})
export default class extends Vue {
  public collection = app.restaurantCollection;

  public model: Restaurant = new Restaurant({}, this.collection);
  public selectedModel: Restaurant | null = null;

  public dialog = false;
  public formTitle: string = "Edit Restaurant Profile";

  public currencies = [
    { code: "cad", text: "Canadian Dollar (CAD)"},
    { code: "zar", text: "South African Rand (ZAR)"},
    { code: "usd", text: "US Dollar (USD)" },
    { code: "eur", text: "Euro (EUR)"},
    { code: "jpy", text: "Japanese Yen (JPY)"},
    { code: "gbp", text: "The Pound Sterling (GPB)"},
    { code: "aud", text: "Australian Dollar (AUD)"},
    { code: "chf", text: "Swiss Franc (CHF)"},
    { code: "cnh", text: "Chinese Renminbi (CNH)"},
    { code: "nzd", text: "New Zealand Dollar (NZD)"},
  ];

  public mounted() {
    this.loadCurrentUser();
  }

  private async loadCurrentUser() {
    const user = app.loginService.currentUser();
    this.model = await this.collection.findByID(user.restaurant_id);
  }

  public async save() {
    try {
      console.log(this.model);
      await this.model.save();
      this.dialog = false;
      this.$store.dispatch("showSnackbar", { message: "Saved succesfully!" });
    } catch (e) {
      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }

  private async onFileSelect(file: any) {
    if (file) {
      const response = await app.uploadService.upload(
        file,
        "/restaurants/upload/" + this.model.id
      );
      this.$store.dispatch("showSnackbar", {
        message: "Image uploaded succesfully!"
      });
      app.refreshData();
    }
  }
}
